@use '../../design-tokens/typography/typography' as *;
@use '../../design-tokens/border-radius/border-radius' as *;

@layer design-system {
  .container {
    display: flex;
    flex-direction: column;
  }

  .groupColumn {
    display: flex;
    flex-direction: column;
  }

  .groupRow {
    display: flex;
    flex-direction: row;
  }

  .groupLabel {
    @include typography-v2-body-md;
  }

  .labelContainer {
    display: flex;
    align-items: center;
  }

  .styledIcon {
    margin-right: 4px;
  }

  .lockIcon {
    margin-right: 14px;
    fill: var(--surface-neutral);
  }

  .inputIcon {
    margin-right: 6px;
  }

  .radioInput {
    appearance: none;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    @include border-radius-full;
    width: 18px;
    height: 18px;
    border: 1px solid var(--border-default);

    &:focus-visible {
      outline-offset: 2px;
      outline: 2px solid var(--border-focus);
    }

    &:checked {
      box-shadow: inset 0 0 0 2px var(--surface-default);
      background: var(--surface-primary);
      border-color: var(--border-primary);
    }

    &:checked::before {
      transform: scale(1);
    }
  }

  .radioInputDisabled {
    border-color: var(--border-disabled);
  }

  .radioInputError {
    border-color: var(--border-critical);
  }

  .radioInputLocked {
    width: 0;
    height: 0;
    padding: 0;
    overflow: hidden;
    margin: 0;
    border: none;
  }

  .radioInputUnlocked {
    &:hover:not(:checked) {
      border-color: var(--border-hover);
    }
  }

  .radioLabel {
    display: flex;
    align-items: center;
    margin: 4px 6px;

    & .radioInput {
      margin: 0 12px 0 0;
    }
  }

  .radioLabelMedium {
    @include typography-v2-body-base;
  }

  .radioLabelSmall {
    @include typography-v2-body-sm;
  }

  .radioLabelDisabled {
    pointer-events: none;
  }

  .radioLabelInactive {
    color: var(--surface-neutral);
  }

  .radioLabelEnabled {
    &,
    & .radioInput {
      cursor: pointer;
    }
  }

  .radioLabelLocked {
    & .radioInput {
      margin: 0;
    }
  }

  .label {
    display: inline-flex;
    align-items: center;
    flex-grow: 1;
  }

  .labelWithTooltip {
    border-bottom: 1px dashed var(--border-default);
  }
}
